import { Button } from "../../../../components";
import { Text, VStack, Stack, } from "native-base";
import Spinner from "react-native-loading-spinner-overlay";
import { useAuthContext, useSupplierContext } from "../../../../contexts";
import { Modal, Pressable, StyleSheet, View } from "react-native";
import { ParamListBase, RouteProp, useFocusEffect, } from "@react-navigation/native";
import { useCallback, useState } from "react";
import moment from "moment";
import { CommunicationList } from "../CommunicationList";
import { DrawerNavigationProp } from "@react-navigation/drawer";
import { getCommunicationList, postCommunicationHeader } from "../../../../services/communicationService";
import { SearchCommunication } from "../SearchCommunication";
import { ModalAlert } from "../../../../components/ModalAlert";
export interface ICommunicationItem {
  creation_date: string;
  status: string;
  qty: number;
  id: string;
  communication_order_header_status_id: number;
}

export const Communication = ({ route, navigation }: { route: RouteProp<ParamListBase, string>; navigation: DrawerNavigationProp<ParamListBase> }) => {
  const { currentSupplier } = useSupplierContext();
  const { token } = useAuthContext();
  const [communicationListData, setCommunicationListData] = useState<ICommunicationItem[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(15);
  const [isLoading, setIsLoading] = useState(false);
  const [lastOrder, setLastOrder] = useState<ICommunicationItem | null>(null);
  const [searchStatus, setSearchStatus] = useState<any>();
  const [showAlert, setShowAlert] = useState(false);
  const [searchClassfication, setSearchClassfication] = useState<any>();
  const [searchInitialDate, setSearchInitialDate] = useState<string>();
  const [searchFinalDate, setSearchFinalDate] = useState<string>();

  const handleCloseAlert = () => {
    setShowAlert(false);
    navigation.navigate("HomeScreen");
  };

  useFocusEffect(
    useCallback(() => {
      loadApi();
    }, [currentSupplier, searchStatus, searchInitialDate, searchFinalDate, route])
  );

  async function getCommunicationListData(id: number, searchStatus: string, searchClassfication: string, searchInitialDate: string, searchFinalDate: string, offset: number, limit: number) {
    try {
      const communicationList = await getCommunicationList(id, searchStatus, searchClassfication, searchInitialDate, searchFinalDate, offset, limit);
      if (communicationList?.status) {
        return communicationList.result;
      } else {
        return [];
      }
    } catch (error: any) {
      console.error(error);
      if (error.response && error.response.status === 400 && !currentSupplier) {
        setShowAlert(true);
      }
      return [];
    }
  }

  async function loadApi() {
    if (isLoading) return;
    setIsLoading(true);
    const response = await getCommunicationListData(currentSupplier, searchStatus, searchClassfication, searchInitialDate, searchFinalDate, offset, limit);
    if (communicationListData) {
      setCommunicationListData([...communicationListData, ...response]);
    }

    if (response.length > 0) {
      setOffset(offset + limit);
    }

    setIsLoading(false);
  }
  function handleSearch(
    status?: string,
    classfication?: string,
    initialDate?: string,
    finalDate?: string
  ) {
    let iDate;
    let fDate;

    if (initialDate) {
      iDate = moment(initialDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (finalDate) {
      fDate = moment(finalDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }

    if (status === "0") {
      setSearchStatus(undefined);
    } else {
      setSearchStatus(status);
    }
    if (classfication === "0") {
      setSearchClassfication(undefined);

    } else {
      setSearchClassfication(classfication);
    }
    setSearchInitialDate(iDate);
    setSearchFinalDate(fDate);
    setOffset(0);
    setCommunicationListData([]);
  }

  function handleItemSelect(headerId: string) {
    navigation.navigate("CommunicationItemListScreen", { headerId: headerId });
  }

  function handleRequestCommunication() {
    const lastOrderWithStatusOne = communicationListData?.reduce<ICommunicationItem | null>((prevOrder, currOrder) => {
      if (
        currOrder.communication_order_header_status_id === 1 &&
        (!prevOrder || currOrder.creation_date > prevOrder.creation_date)
      ) {
        return currOrder;
      }
      return prevOrder;
    }, null);

    if (lastOrderWithStatusOne) {
      setModalVisible(true);
      setLastOrder(lastOrderWithStatusOne);
    } else {
      createCommunication();
    }
  }

  async function createCommunication() {
    setModalVisible(false);
    if (currentSupplier) {
      const data = await postCommunicationHeader(currentSupplier);
      if (data?.status) {
        const headerId = data.result.communicationHeaderId;
        navigation.navigate("CommunicationItemListScreen", {
          headerId: headerId,
        });
      }
    }
  }

  return (
    <>
      <VStack flex={1} _web={{ px: 20, w: "100%" }} bg="#fff">
        <SearchCommunication handleSearch={handleSearch} />
        <CommunicationList
          communicationListData={communicationListData}
          handleItemSelect={handleItemSelect}
          onEndReached={loadApi}
          onEndReachedThreshold={0.1}
          isLoading={isLoading}
        />

        <Stack px={10} py={2}>
          <Button
            label="Comunicar"
            onPress={() => handleRequestCommunication()}
          />
        </Stack>
      </VStack>

      <Modal
        animationType="slide"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {
          setModalVisible(!modalVisible);
        }}
      >
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            <Text style={styles.modalText}>Já existe uma solicitação</Text>
            <Text style={styles.modalText}>"EM PREENCHIMENTO".</Text>
            <Text style={styles.modalText}>Deseja criar uma nova?</Text>
            <View style={styles.buttons}>
              <Pressable
                style={[styles.button, styles.buttonClose]}
                onPress={() => {
                  setModalVisible(false);
                  if (lastOrder) {
                    navigation.navigate("CommunicationItemListScreen", {
                      headerId: lastOrder.id,
                    });
                  }
                }
                }
              >
                <Text style={styles.textStyle}>Manter Atual</Text>
              </Pressable>
              <Pressable
                style={[styles.button, styles.buttonClose]}
                onPress={() => createCommunication()}
              >
                <Text style={styles.textStyle}>Criar Nova</Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      <ModalAlert isVisible={showAlert} onClose={handleCloseAlert} />
      <Spinner visible={isLoading} />
    </>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 22,
  },
  modalView: {
    margin: 20,
    backgroundColor: "white",
    borderRadius: 20,
    padding: 35,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  button: {
    borderRadius: 20,
    paddingLeft: 20,
    paddingRight: 20,
    padding: 10,
    elevation: 2,
    marginLeft: 10,
    marginRight: 10,
  },
  buttonOpen: {
    backgroundColor: "#F194FF",
  },
  buttonClose: {
    backgroundColor: "#2196F3",
  },
  textStyle: {
    color: "white",
    fontWeight: "bold",
    textAlign: "center",
  },
  modalText: {
    marginBottom: 10,
    textAlign: "center",
  },
  buttons: {
    display: "flex",
    flexDirection: "row",
  },
});
